import type { TExposedCompanyDTO, TUpdateCompanyInputDTO } from '@doutorsim/shared/companies'
import { UpdateCompanyInputDTOSchema } from '@doutorsim/shared/companies'
import { zodResolver } from '@hookform/resolvers/zod'
import type { ReactNode } from 'react'
import { FormProvider as _FormProvider, useForm } from 'react-hook-form'

interface FormProviderProps {
  company: TExposedCompanyDTO
  children: ReactNode
}

export const FormProvider = ({ company, children }: FormProviderProps) => {
  const methods = useForm<TUpdateCompanyInputDTO>({
    resolver: zodResolver(UpdateCompanyInputDTOSchema),
    shouldUnregister: false,
    defaultValues: {
      id: company.id,
      name: company?.name,
      legalName: company?.legalName ?? '',
      cnpj: company?.cnpj,
      franchiseId: null,
      requiresHandoff: company?.requiresHandoff ?? false,
    },
  })

  return <_FormProvider {...methods}>{children}</_FormProvider>
}
